import './agent_profile_editor';
import './api_tokens';
import './boot';
import './channels_admin';
import './customer_combine';
import './customer_view';
import './external_customer_lookup';
import './forgot_password';
import './floorboard';
import './inbox';
import './inboxes_admin';
import './kb_admin';
import './liveboards';
import './reports';
import './rules';
import './search';
import './snippet_editor';
import './team_editor';
import './user_activation';
import './user_editor';
import './user_login';
import './user_reset_password';
import './users_admin';



// WEBPACK FOOTER //
// ./factories/location/index.js